// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// The fallback used to be the sslip.io kong host, which no longer answers. A
// build that forgot to export VITE_SUPABASE_URL therefore produced a bundle
// pointing at a dead URL, with no build error and no warning: every call failed
// as "Failed to fetch" before leaving the browser, so the server logs stayed
// empty and it presented as a rejected password. Keep this on the public API.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://omniapi.jmcworld.xyz';
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzdXBhYmFzZSIsImlhdCI6MTc2ODg4MzE2MCwiZXhwIjo0OTI0NTU2NzYwLCJyb2xlIjoiYW5vbiJ9.ivJ8f8OH5cPUK-1mLYrKfGXGaBmZFU-DrEC7FT_gO60';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});